export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      url: this.modelValue.data.url
    }
  },
  computed: {
    element: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    updateUrl(callback = null) {
      this.element.data.url = this.url
      this.element.updated = true
      callback && callback()
    }
  },
  watch: {
    'modelValue.data.url': {
      immediate: true,
      handler(val) {
        this.url = val
      }
    }
  }
}
